import mongoose from "mongoose"
import { Cliente, ClienteCreated } from "../../api/models/clientes"
import { ClienteInput } from "./types"

export async function getClientes(
  pageNumber: number,
  limitNumber: number,
  filters: Record<string, any> = {}
) {
  try {
    // Convert the filters object to a query string
    const filterParams = new URLSearchParams({
      filters: JSON.stringify(filters),
    }).toString()

    // Construct the URL with the page, limit, and filters
    const urlWithParams = `/.netlify/functions/get_clientes?page=${pageNumber}&limit=${limitNumber}${filterParams ? "&" + filterParams : ""}`

    // Fetch the data from the API
    const response = await fetch(urlWithParams)
    // Check if the response is ok (status code 200-299)
    if (!response.ok) {
      throw new Error("Failed to fetch cars")
    }

    // Return the parsed JSON data
    return response.json()
  } catch (error) {
    console.error(error)
    throw new Error("Cars could not be loaded")
  }
}

// The editCar function with explicit type
export async function editCliente(
  id: string,
  clienteData: Cliente
): Promise<ClienteCreated> {
  const urlWithParams = `/.netlify/functions/edit_cliente?id=${id}` // URL for your Netlify function

  try {
    const response = await fetch(urlWithParams, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(clienteData), // Pass the car data to update
    })

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`)
    }

    return response.json() // Return the updated car information
  } catch (error) {
    console.error(error)
    throw new Error("Car could not be edited")
  }
}

export async function createCliente(
  clienteData: object
): Promise<ClienteCreated> {
  const url = `/.netlify/functions/create_cliente` // URL for your Netlify function to create a car

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(clienteData), // Pass the car data to create
    })

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`)
    }

    return response.json() // Return the created car information
  } catch (error) {
    console.error(error)
    throw new Error("Car could not be created")
  }
}

export const createClientePayload = ({
  nombre,
  celular,
  email,
}: ClienteInput) => {
  return {
    _id: new mongoose.Types.ObjectId(),
    nombre,
    celular,
    email,
  }
}
